var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileNewChatIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7869 15.6324V7.86765M9.91764 11.75H17.6562M13.7869 22.75C19.8416 22.75 24.7499 17.8251 24.7499 11.75C24.7499 5.67487 19.8416 0.75 13.7869 0.75C7.73223 0.75 2.82391 5.67487 2.82391 11.75C2.82391 12.9794 3.02492 14.1617 3.39577 15.2656C3.53531 15.681 3.60509 15.8887 3.61767 16.0483C3.63011 16.2059 3.62071 16.3164 3.58186 16.4695C3.54251 16.6247 3.45564 16.7861 3.28191 17.1087L1.17229 21.0268C0.871372 21.5856 0.720908 21.865 0.754584 22.0807C0.783913 22.2685 0.894098 22.4338 1.05587 22.5328C1.2416 22.6466 1.55646 22.6139 2.18619 22.5486L8.79111 21.8635C8.99113 21.8428 9.09114 21.8325 9.1823 21.836C9.27195 21.8393 9.33524 21.8479 9.42267 21.8681C9.51157 21.8886 9.62335 21.9319 9.84691 22.0182C11.0696 22.4909 12.3981 22.75 13.7869 22.75Z",
    stroke: "#E1E1E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileNewChatIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MobileNewChatIcon.352637c3e76ebaa5a3b963e9e85e09d3.svg";